import React, { useState, useEffect } from "react";
import { useWindowSize } from "react-use";
import Confetti from "react-confetti";
import Footer from "../../mykad_verification/components/Footer";
import { CircleCheck } from "lucide-react";

const Success = ({ onDone, uiConfig }) => {
  // Safe access
  const global = uiConfig?.Global || {};
  const cardBgColor = global?.card?.backgroundColor || "#f3f4f6"; // gray-50
  const cardOpacity = global?.card?.opacity || "1"; // default opacity
  const pageBgColor = global?.pageContainer?.backgroundColor || "#ffffff"; // white
  const textColor = global?.text?.fontColor || "#6b7280"; // default gray-500
  const { width, height } = useWindowSize();

  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          status: "success",
          message: "Verification Successful",
        })
      );
    }

    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler(
        "KenalFlutterWebViewChannel",
        JSON.stringify({
          status: "success",
          message: "Verification Successful",
        })
      );
    }

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (countdown === 0) {
      onDone();
    }
  }, [countdown]);

  return (
    <div className="min-h-screen w-full bg-gray-50 flex justify-center items-center">
      <div
        style={{
          background: pageBgColor,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          padding: "1rem",
          height: "100%",
        }}
      >
        <Confetti width={width} height={height} numberOfPieces={20} />
        <div
          style={{
            background: cardBgColor,
            opacity: cardOpacity,
            padding: "2rem",
            borderRadius: "1rem",
            marginTop: "calc(100vh / 16)",
            marginBottom: "2rem",
          }}
        >
          <div className="flex flex-col">
            <p className="text-2xl font-medium">Verification Complete!</p>
            <p className="text-gray-500 text-md mt-4">
              Thank you! Your identity has been <strong>successfully</strong>{" "}
              verified.
            </p>
          </div>
          <div className="flex flex-col items-center mt-8">
            <CircleCheck height="72" width="72" color="green" />
          </div>

          <div className="flex flex-col items-center mt-8">
            You'll be continuing the process in {countdown} seconds...
          </div>
        </div>

        <div className="flex flex-1" />

        <Footer
          style={{
            fontSize: "0.75rem",
            color: textColor,
            marginTop: "1rem",
          }}
        />
      </div>
    </div>
  );
};

export default Success;
